<template>
    <div>
        <v-checkbox v-if="getField(field)" :disabled="field ? field.DISABLED : false" :label="getLabel(field)"
            :input-value="value" @change="updateValue">

            <!-- Tooltip mit Hint, falls vorhanden -->
            <template v-slot:append>
                <v-tooltip bottom v-if="field.HELP">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                    </template>
                    <span>{{ field ? field.HELP : '' }}</span>
                </v-tooltip>
            </template></v-checkbox>
    </div>
</template>

<script>
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';

export default {
    name: 'aedCheckbox',
    mixins: [fieldMixin, helperMixin],
    props: {
        /**
         * Field definition object containing configuration like label, help text, and disabled state.
         * @type {Object}
         */
        field: Object,

        /**
         * The current boolean value of the checkbox (v-model binding).
         * @type {boolean}
         */
        value: Boolean,
    },
    methods: {
        /**
         * Emits the updated checkbox value to the parent component.
         * 
         * @param {boolean} newValue - The new checkbox state
         */
        updateValue(newValue) {
            this.$emit('input', newValue);
        },
    },
};
</script>
